import { ModuleConfig } from '@core/interfaces';
import { name as members } from '@modules/Members/reducers/members';

const config: ModuleConfig = {
  name: 'Inquiry',
  baseUrl: '',
  routes: [
    {
      path: '/admin/inquiry',
      page: 'InquiryPage',
      title: 'Warehouse Page',
      exact: true
      //   reducer: {
      //     name: members,
      //     resource: "members",
      //   },
    },
    {
      path: '/admin/inquiry/:id',
      page: 'InquiryDetail',
      title: 'Member Detail Page',
      exact: true
      // reducer: {
      //   name: members,
      //   resource: "members",
      // },
    }
  ],
  requireAuthenticated: true
};

export default config;
